import React from "react";
import Dialog from "@material-ui/core/Dialog";
import { PrimaryCTAButton, PrimaryOutlinedCloseCTAButton } from "../Buttons";
import styled from "styled-components";
import COLORS from "../../../assets/Colors";
import theme from "../../../assets/theme";
import _ from "lodash";

const AlertDialog = ({
  heading = "Quit Case",
  desc = "Are you sure you want to Quit this case? All the negotiation progress will be lost if you quit case at this point",
  primaryBtnText = "Submit",
  secondaryBtnText = "Close",
  secondaryBtnPrimaryText,
  clickSecondarybtn = () => {},
  clickSecondaryPrimarybtn = () => {},
  clickPrimaryBtn = () => {},
  isOpen = false,
  onDialogClose = () => {},
  descriptionTextStyle = {},
}) => {
  const isPrimaryAction = (text) => {
    return (
      text === "Proceed" ||
      text === "Submit" ||
      text === "Logout" ||
      text === "Quit" ||
      text === "Add to Payments" ||
      text === "Yes, Generate" ||
      text === "Remove" ||
      text === "Accept" ||
      text === "Add to Cart" ||
      _.lowerCase(text) === "ok" ||
      _.lowerCase(text) === "decline"
    );
  };

  return (
    <StyledDialog
      open={isOpen}
      onClose={onDialogClose}
      disableRestoreFocus={true}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogContent>
        <Heading>{heading}</Heading>

        <Description style={{ ...descriptionTextStyle }}>{desc}</Description>

        <ButtonWrapper>
          {secondaryBtnText && (
            <ButtonContainer className="btn">
              {isPrimaryAction(secondaryBtnText) ? (
                <PrimaryCTAButton onClick={clickSecondarybtn}>
                  {secondaryBtnText}
                </PrimaryCTAButton>
              ) : (
                <PrimaryOutlinedCloseCTAButton onClick={clickSecondarybtn}>
                  {secondaryBtnText}
                </PrimaryOutlinedCloseCTAButton>
              )}
            </ButtonContainer>
          )}

          {secondaryBtnPrimaryText ? (
            <ButtonContainer className="btn">
              <PrimaryCTAButton onClick={clickSecondaryPrimarybtn}>
                {secondaryBtnPrimaryText}
              </PrimaryCTAButton>
            </ButtonContainer>
          ) : null}

          {primaryBtnText && (
            <ButtonContainer className="btn">
              {isPrimaryAction(primaryBtnText) ? (
                <PrimaryCTAButton onClick={clickPrimaryBtn}>
                  {primaryBtnText}
                </PrimaryCTAButton>
              ) : (
                <PrimaryOutlinedCloseCTAButton onClick={clickPrimaryBtn}>
                  {primaryBtnText}
                </PrimaryOutlinedCloseCTAButton>
              )}
            </ButtonContainer>
          )}
        </ButtonWrapper>
      </DialogContent>
    </StyledDialog>
  );
};

export default AlertDialog;

const StyledDialog = styled(Dialog)`
  & .MuiDialog-paper {
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25) !important;
    overflow: visible !important;
    animation: dialogSlideIn 0.3s ease-out;
  }

  @keyframes dialogSlideIn {
    from {
      opacity: 0;
      transform: scale(0.9) translateY(-20px);
    }
    to {
      opacity: 1;
      transform: scale(1) translateY(0);
    }
  }

  & .MuiBackdrop-root {
    background-color: rgba(0, 0, 0, 0.5) !important;
  }
`;

const DialogContent = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;

  @media ${theme?.breakpoints?.sm_up} {
    padding: 32px 48px;
  }
`;

const Heading = styled.h2`
  font-family: ${theme.fonts.primaryFontExtraBold};
  color: ${COLORS.COLOR_DARK};
  margin: 0 0 16px 0;
  font-size: 18px;
  text-align: center;
  line-height: 1.3;
  font-weight: 800;

  @media ${theme?.breakpoints?.sm_up} {
    font-size: 22px;
    margin: 0 0 20px 0;
  }
`;

const Description = styled.p`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 13px;
  line-height: 1.6;
  color: ${COLORS.COLOR_DARK};
  text-align: center;
  margin: 0 0 28px 0;
  width: 100%;
  max-width: 100%;

  @media ${theme?.breakpoints?.sm_up} {
    font-size: 15px;
    line-height: 1.7;
    max-width: 460px;
    margin: 0 0 36px 0;
  }
`;

const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 12px;

  @media ${theme?.breakpoints?.sm_up} {
    flex-direction: row;
    justify-content: center;
    gap: 16px;
    margin-top: 16px;
    flex-wrap: wrap;
  }
`;

const ButtonContainer = styled.div`
  width: 100%;
  min-width: 140px;

  button {
    width: 100%;
    padding: 14px 24px !important;
    font-weight: 600;
    font-size: 14px;
    transition: all 0.22s ease;
    border-width: 2px !important;
    white-space: nowrap;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 6px 16px rgba(0, 0, 0, 0.14);
    }

    &:active {
      transform: translateY(0);
    }
  }

  @media ${theme?.breakpoints?.sm_up} {
    width: auto;
    flex: 1 1 auto;
    min-width: 148px;
    max-width: 260px;

    button {
      padding: 13px 24px !important;
      font-size: 14px;
    }
  }
`;
